import classNames from "classnames";

import { ChevronForwardIcon } from "@jti/brand-icons/chevron-forward";

import styles from "./NavBar.module.scss";

type LinkElementContentType = {
  text: string;
};

export const LinkElementContent = ({ text }: LinkElementContentType): JSX.Element => (
  <>
    <div className={styles.icon}></div>
    <span className={styles.text}>{text}</span>
    <ChevronForwardIcon className={classNames(styles.icons, styles.chevron)} />
  </>
);
